import * as lan from '../common/script/common_lan.js';

import React, {useState, useEffect} from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import * as common from '../common/script/common';
import $ from 'jquery';
import axios from 'axios';

export function slideOn(){
	$("html").addClass("overflowHidden");
	$("#filter_practiceclub").addClass("on");
}

export function slideExit(){
	$("html").removeClass("overflowHidden");
	$(".layerView").removeClass("on");
}

export default function BottomPracticeClub(props) {
	
	const location = useLocation();
	const navigate = useNavigate();

	const [clubhtmllist, setclubhtmllist] = useState([]);
	

	var list = common.commonKeyDic['club']; 
	var practiceclub;
	var clubdata;
	useEffect(() => {
		
		//연습장 클럽목록
		axios({
			method: 'post',
			url: process.env.REACT_APP_SERVER + '/api',
			data: {type : 2}, //1 게임라운드, 2 연습장
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'language':sessionStorage.getItem('Language'),
				'pUrl' : encodeURIComponent('게임 라운드, 연습장 샷 데이터 기반 클럽 정보 조회'),
				'token' : sessionStorage.getItem('access_token'),
			}
		}).then(function (response) {
				console.log(response.data);

				var htmllist = [];
				
				practiceclub = Object.values(common.commonKeyDic['club'])[0];//전체가 있으므로 값에 +1
				//전체는 별도로 추가
				htmllist.push(
				<a key={"allpracticeclub"}>
					<input type="radio" id={"practicecluball"} name="practiceclub" onClick={(e) =>goSelect(e,props.to)} value={lan.L(practiceclub)} defaultChecked={true}/>
					<label htmlFor={"practicecluball"}>{lan.L(practiceclub)}</label>
				</a>
				);

				for(let i =0; i < response.data.clubs.length; i++)
				{
					var j = response.data.clubs[i];
					practiceclub = Object.values(common.commonKeyDic['club'])[j+1];//전체가 있으므로 값에 +1
					htmllist.push(
					<a key={j+"practiceclub"}>
						<input type="radio" id={"practiceclub"+j} name="practiceclub" onClick={(e) =>goSelect(e,props.to)} value={lan.L(practiceclub)} defaultChecked={lan.LTarget(practiceclub,'en') == lan.LTarget(props.practiceClub,'en') ? true : false}/>
						<label htmlFor={"practiceclub"+j}>{lan.L(practiceclub)}</label>
					</a>
					);
				}
				setclubhtmllist(htmllist);
				
			}).catch(error => {
			console.log(error.response)
		});
    },[]);

	const goSelect = (e, to) => {

		var value = e.target.value;

		if(to !== undefined)
		{
			navigate("/common/script/backnavigation", {state : {gameType : props.gameType,  club : props.club, practiceClub : value, back:to, activeTab : props.activeTab, backgameRoundId : window.localStorage.getItem('practiceGameRoundId'),  backgameRoundNum : window.localStorage.getItem('practiceGameRoundShot')}, replace : true});
		}
		slideExit();
	}

	return (
	<div id="filter_practiceclub" className="layerView">
	<button style={{display:'none'}} onClick={(e) =>goSelect(e,props.to)} value={lan.L(Object.values(common.commonKeyDic['club'])[0])} id="pop_practiceclubinit">{lan.L("초기화")}</button>
	  <div className="bottom_sheet">
		<a onClick={(e) => slideExit()}>close</a>
		<div className="bs_body">
		  <em>{lan.L("골프 클럽 선택")}</em>
		  <div className="scroll_container">
			<div className="list_selection">
			 {clubhtmllist}
			</div>
		  </div>
		</div>
	  </div>
	</div>
	)
}

// import * as lan from '../common/script/common_lan.js';
// import React, {useState, useEffect} from 'react';
// import { useNavigate, useLocation } from "react-router-dom";
// import * as common from '../common/script/common';
// import $ from 'jquery';
// import axios from 'axios';
// export function slideOn(){
// 	$("html").addClass("overflowHidden");
// 	$("#filter_practiceclub").addClass("on");
// }
// export function slideExit(){
// 	$("html").removeClass("overflowHidden");
// 	$(".layerView").removeClass("on");
// }
// export default function BottomPracticeClub(props) {
	
// 	const location = useLocation();
// 	const navigate = useNavigate();
// 	const [clubhtmllist, setclubhtmllist] = useState([]);
// 	var list = common.commonKeyDic['club']; 
// 	var practiceclub;
// 	useEffect(() => {
// 		var htmllist = [];
// 		for(let i =0; i < Object.keys(list).length; i++)
// 		{
// 			practiceclub =  lan.L(Object.values(common.commonKeyDic['club'])[i]);
// 			htmllist.push(
// 			  <a key={i+"practiceclub"}>
// 				<input type="radio" id={"practiceclub"+i} name="practiceclub" onClick={(e) =>goSelect(e,props.to)} value={practiceclub} defaultChecked={practiceclub == props.practiceClub ? true : false}/>
// 				<label htmlFor={"practiceclub"+i}>{practiceclub}</label>
// 			  </a>
// 			);
// 		}
// 		setclubhtmllist(htmllist);
//     },[]);
// 	const goSelect = (e, to) => {
// 		var value = e.target.value;
// 		if(to !== undefined)
// 		{
// 			navigate(to, {state : {gameType : props.gameType,  club : props.club, practiceClub : value, back:to, activeTab : props.activeTab}, replace : true});
// 		}
// 		slideExit();
// 	}
// 	return (
// 	<div id="filter_practiceclub" className="layerView">
// 	  <div className="bottom_sheet">
// 		<a onClick={(e) => slideExit()}>close</a>
// 		<div className="bs_body">
// 		  <em>{lan.L("골프 클럽 선택")}</em>
// 		  <div className="scroll_container">
// 			<div className="list_selection">
// 			 {clubhtmllist}
// 			</div>
// 		  </div>
// 		</div>
// 	  </div>
// 	</div>
// 	)
// }